var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"delete-access",attrs:{"disabled":_vm.loading},on:{"click":function($event){return _vm.handleDestroy()}}},[_c('i',{staticClass:"fa fa-trash-o mr-1",staticStyle:{"font-size":"18px"}}),_vm._v(" "+_vm._s(_vm.__(_vm.message))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }